import { createSlice } from '@reduxjs/toolkit';
// utils
import axiosIntanceAccessZalo from '../../helper/axiosIntanceApiZalo';
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  // info:{error:"",description: "", name: "VOIP24H CSKH", avatar: "https://s240-ava-talk.zadn.vn/c/1/5/c/2/240/b6080ea59f95c7a6d06d2a2c0bb9e299.jpg", cover: "", oa_id: "3440269002545629199", is_verified: ""},
  info: { error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "" },
  list_oa: [{ error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "" }]
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'zalo',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    //GET INFO ZALO
    getInfoZaloSuccess(state, action) {
      const participants = action.payload;
      state.info = participants;
    },
    getListZaloOaSuccess(state, action) {

      const participants = action.payload;
      if (action.payload.length && action.payload.length > 0) {
        state.list_oa = action.payload.length < 5 ? action.payload.concat([{ error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "" }]) : action.payload;
      } else {
        state.list_oa = [{ error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "" }];
      }
      //  state.list_oa = participants;
    }
  }
});

// Reducer
export default slice.reducer;


//---------------------------INFO OA ZALO-------------------------------------------
//TYPE :  POST
//PARAM : Header:{ access_token}
//RESPONSE
// oa_id |	long	ID của OA được lấy thông tin
// description | 	string	Mô tả của OA
// name |	string	Tên của OA
// avatar	| string	Đường dẫn đến ảnh đại diện của OA
// cover | string|	Đường dẫn đến ảnh bìa của OA
// is_verified | 	boolean	| Trạng thái xác thực của OA ( false: OA chưa được xác thực ,true: OA đã xác thực)  


export function getInfoZalo(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosIntanceAccessZalo.post('/getoa', param);
      if (response.data?.data) {
        dispatch(slice.actions.getInfoZaloSuccess(response.data.data));
      }
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getListZaloOa(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosIntanceAccessZalo.post('/listOa', param);
      if (response.data?.data) {
        var oa_ids=[];
        response.data.data.list_zalo_oa.map(oa =>oa_ids.push(oa.oa_id))
        localStorage.setItem('oa_ids',JSON.stringify(oa_ids))
        dispatch(slice.actions.getListZaloOaSuccess(response.data.data.list_zalo_oa));
      }
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
